import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable()
export class CustomIconService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
  ) {}

  init() {
    this.addSvgIcon('mdi-plus-circle-outline', '../../../assets/icons/add_icon.svg'); // fallback
    this.addSvgIcon('mdi-cog-outline', '../../../assets/icons/settings_icon.svg'); // fallback (remove)

    this.matIconRegistry.addSvgIconSet(this.domSanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/_ALL.svg'));
  }

  private addSvgIcon(iconName: string, fileName: string) {
    this.matIconRegistry.addSvgIcon(iconName, this.domSanitizer.bypassSecurityTrustResourceUrl(fileName));
  }
}
